import { ApolloListItemType } from 'core/types/ApolloListQuery';
import { SearchCandidateProfileListsQuery } from 'generated-graphql/graphql';
import { CandidateProfileTalentListTableColumns } from 'modules/candidate-profile/tables/types/CandidateProfileTalentListTable';

type SearchCandidateProfileListItem =
  ApolloListItemType<SearchCandidateProfileListsQuery>;

type MapCandidateProfileTalentListTableColumnsProps = {
  data: SearchCandidateProfileListItem[];
};

export const mapCandidateProfileTalentListTableColumns = ({
  data
}: MapCandidateProfileTalentListTableColumnsProps): CandidateProfileTalentListTableColumns[] => {
  return data.map((item) => ({
    id: item.id,
    title: item.title,
    candidatesCount: item.candidateProfilesCount,
    description: item.description ?? null,
    updatedAt: item.updatedAt,
    owner: item.userName ?? '',
    teams: item.teams
  }));
};
